import { crisisNegotiationPlaybook } from "./crisisNegotiation";
import { PLAYBOOK_IDS, type Playbook, type PlaybookId } from "./types";

export const PLAYBOOKS: Record<PlaybookId, Playbook> = {
  "crisis-negotiation": crisisNegotiationPlaybook,
};

/** In the order a learner is offered them. */
export const PLAYBOOK_LIST: Playbook[] = PLAYBOOK_IDS.map((id) => PLAYBOOKS[id]);

export function isPlaybookId(value: unknown): value is PlaybookId {
  return (
    typeof value === "string" &&
    (PLAYBOOK_IDS as readonly string[]).includes(value)
  );
}

export function getPlaybook(id: PlaybookId): Playbook {
  return PLAYBOOKS[id];
}
